import { itiMessageService, itiPermissionService, itiTokenService } from '@/iti-core-vue';
import templatesModule from '@/store/modules/templates.module';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ItiIconButton } from '@/iti-core-vuetify';
import { ValidationProvider } from 'vee-validate';
import DxSelectBox from 'devextreme-vue/select-box';
import DxCheckBox from 'devextreme-vue/check-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxNumberBox from 'devextreme-vue/number-box';
import DxButton from 'devextreme-vue/button';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import {
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxStringLengthRule,
} from 'devextreme-vue/validator';
import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';
import es from "../../../../public/assets/lang/es.json";
import va from "../../../../public/assets/lang/va.json";
import { locale, loadMessages } from 'devextreme/localization';
import { Permission } from '@/shared/permissions';
import { FieldType } from '@/shared/dtos/field-type';

@Component({
    components: {
        ValidationProvider,
        ItiIconButton,
        DxSelectBox,
        DxCheckBox,
        DxTextBox,
        DxTextArea,
        DxNumberBox,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        DxStringLengthRule,
        DxValidationSummary,
        DxPopup,
        DxPosition,
        DxToolbarItem,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser

    },
})

export default class NuevoCampoFormulario extends Vue {

    @Prop() idPlantilla !: number;
    @Prop() idVersion!: number;
    @Prop() idCampo !: number;
    public errors: String = "";
    public minValue: number = 0;
    public maxValue: number = 0;
    public showListType = false;
    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public isEditingListValour = false;
    public previousType: String = "";

    public get editField() {
        if (!templatesModule.selectedField.obligatory) templatesModule.selectedField.obligatory = false;
        if (!templatesModule.selectedField.readOnly) templatesModule.selectedField.readOnly = false;
        return templatesModule.selectedField;
    }

    public get fieldTypes() {
        return templatesModule.fieldTypes;
    }

    public get unitTypes() {
        return templatesModule.unitTypes;
    }

    public get fieldTitle() {
        if (templatesModule.selectedField.code == null || templatesModule.selectedField.code.length == 0) {
            return this.$t('plantillas.nuevoCampo');
        } else {
            return templatesModule.selectedField.code;
        }
    }

    public get editListValours() {
        return templatesModule.values;
    }

    public get removeListValours() {
        return templatesModule.removeValues;
    }

    public get minRangeValue() {
        return templatesModule.values[0];
    }

    public get maxRangeValue() {
        return templatesModule.values[1];
    }

    public get rangeType() {
        if (this.editField.fieldType) {
            var isRange = this.editField.fieldType.code == "Rango";
            if (isRange && this.previousType == "Listado") {
                this.editListValours.forEach(element => {
                    templatesModule.addValueToRemoveFromList(element);
                });
                templatesModule.resetValues();
            }
            this.previousType = this.editField.fieldType.code; //Solo lo ponemos en rangeType y no en listType para que no surgan conflictos al modificar el valor de la variable                          
            return isRange
        }
        else {
            return false;
        }
    }

    public get listType() {
        if (this.editField.fieldType) {
            var isList = this.editField.fieldType.code == "Listado";
            if (isList && this.previousType == "Rango") {
                this.editListValours.forEach(element => {
                    templatesModule.addValueToRemoveFromList(element);
                });
                templatesModule.resetValues();
            }
            return isList;
        }
        else {
            return false;
        }
    }

    public get language() {
        return this.$root.$i18n.locale.toString();
    }

    public get hasPermission() {
        return itiPermissionService.hasPermission(Permission.updateTemplates);
    }

    public created() {
        locale(this.language);
        loadMessages(va);
        loadMessages(es);

        templatesModule.getTemplateVersionById(this.idVersion)
            .then(() => {
                templatesModule.setFieldToEditById(this.idCampo);

                templatesModule.getValuesByFieldId(this.idCampo)
                    .then(() => {
                        if (this.editField.fieldType && this.editField.fieldType.code == "Rango") this.assignRange();
                    })

            });
    }

    public mounted() {
        templatesModule.getFieldTypes();
        templatesModule.getUnitTypes();
    }

    public async saveNewField() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-guardar'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                if (this.editField.id != null) {
                    templatesModule.updateField(this.editField);
                    if (this.rangeType) this.saveRangeListValours();
                } else {
                    this.editField.id = 0;
                    this.editField.multipleSelector = true;                 
                    templatesModule.selectedTemplateVersion.fields.push(this.editField);
                }
                templatesModule.saveTemplateVersion(templatesModule.selectedTemplateVersion)
                    .then(() => {
                        if (!this.rangeType && !this.listType && this.editListValours.length > 0) this.removeExistingListValours();
                        if (this.rangeType && this.minRangeValue == null) this.saveNewRangeListValours();
                        if (this.listType) this.saveListListValours();
                        if (templatesModule.selectedTemplateVersion.id != null) {
                            this.$router.push({ name: 'VersionFormulario', params: { id: templatesModule.selectedTemplateVersion.id.toString() } });
                        } else {
                            this.$router.push({ name: 'ListaPlantillas' });
                        }
                    })
                    .catch(() => {
                        itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
                    });
            }
        });
    }

    public cancelNewField() {
        itiMessageService.confirm(this.$tc('mensajes-plantillas.pregunta-salir'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                templatesModule.resetRemoveValues();

                this.$router.push({ name: 'VersionFormulario', params: { idPlantilla: this.idPlantilla.toString(), idVersion: this.idVersion.toString() } });

            }
        });
    }

    public setNameFieldType(fieldType: FieldType) {
        if (fieldType != null) {
            return this.$tc('enum-plantillas.' + fieldType.code);
        }
    }

    public checkFieldType() {
        var correctCode;
        if (this.editField.fieldType) {
            if (templatesModule.fieldTypes.length != 0) {
                templatesModule.fieldTypes.forEach(element => {
                    if (this.editField.fieldType.code === element.code) correctCode = this.editField.fieldType;
                });
            } else {
                correctCode = this.editField.fieldType;
            }
        }
        return correctCode;
    }

    public checkUnitType() {
        var correctCode;
        if (this.editField.unitType) {
            if (templatesModule.unitTypes.length != 0) {
                templatesModule.unitTypes.forEach(element => {
                    if (this.editField.unitType.code === element.code) correctCode = this.editField.unitType;
                });
            } else {
                correctCode = this.editField.unitType;
            }
        }
        return correctCode;
    }

    public assignRange() {
        if (this.minRangeValue.id) {
            this.minValue = +this.minRangeValue.value;
        }
        if (this.maxRangeValue.id) {
            this.maxValue = +this.maxRangeValue.value;
        }
    }

    public saveNewRangeListValours() {
        templatesModule.initializeValuesRange();
        this.minRangeValue.value = this.minValue.toString();
        this.minRangeValue.fieldId = templatesModule.idLastFieldCreated;
        this.minRangeValue.id = 0;
        templatesModule.saveValues(this.minRangeValue)
            .then(() => {
                this.maxRangeValue.value = this.maxValue.toString();
                this.maxRangeValue.fieldId = templatesModule.idLastFieldCreated;
                this.maxRangeValue.id = 0;
                templatesModule.saveValues(this.maxRangeValue)
            });
        this.removeOldListValours();
    }

    public saveRangeListValours() {
        if (this.minRangeValue == null) templatesModule.initializeValuesRange();
        this.minRangeValue.value = this.minValue.toString();
        this.minRangeValue.fieldId = this.editField.id;
        if (this.minRangeValue.id == null) this.minRangeValue.id = 0;
        templatesModule.saveValues(this.minRangeValue)
            .then(() => {
                this.maxRangeValue.value = this.maxValue.toString();
                this.maxRangeValue.fieldId = this.editField.id;
                if (this.maxRangeValue.id == null) this.maxRangeValue.id = 0;
                templatesModule.saveValues(this.maxRangeValue);
            });
        this.removeOldListValours();
    }

    public saveListListValours() {
        this.editListValours.forEach(async element => {
            if (element.fieldId == null) {
                element.id = 0; //Es un elemento nuevo añadido a una lista existente
                if (this.editField.id != null && this.editField.id != 0) {
                    element.fieldId = this.editField.id;
                } else {
                    element.fieldId = templatesModule.idLastFieldCreated;
                }
            }
            await templatesModule.saveValues(element);
        });
        this.removeOldListValours();
    }

    public removeOldListValours() {
        var sizeList = this.removeListValours.length;
        for (let i = 0; i < sizeList; i++) {
            var deleteValue = templatesModule.removeValues.pop();
            if (deleteValue) templatesModule.deleteValues(deleteValue);
        }
    }

    public removeExistingListValours() {
        var sizeList = this.editListValours.length;
        for (let i = 0; i < sizeList; i++) {
            var deleteValue = templatesModule.values.pop();
            if (deleteValue) templatesModule.deleteValues(deleteValue);
        }
    }

    public checkMinMax() {
        var correctMinMax;
        if (this.minValue < this.maxValue) {
            correctMinMax = this.maxValue;
        }
        return correctMinMax;
    }

    public listValoursEditMode() {
        if (!this.showListType) {
            this.showListType = true;
        }
        else if (this.isEditingListValour) {
            itiMessageService.confirm(this.$tc('mensajes-plantillas.campos-sin-guardar'), this.$tc('mensajes.confirmar'), (res) => {
                if (res) {
                    this.showListType = false;
                }
            });
        } else {
            this.showListType = false;
        }
    }

    public rowInserted(e: any) {
        e.data.id = this.editListValours.length;
    }

    public rowUpdated(e: any) {
    }

    public rowRemoved(e: any) {
        if (e.data.fieldId != null) templatesModule.addValueToRemoveFromList(e.data);
    }

    public initNewRow(e: any) {
        e.data.id = 0;
        this.isEditingListValour = true;
    }

    public editingStart() {
        this.isEditingListValour = true;
    }

    public saving() {
        this.isEditingListValour = false;
    }

    public editCanceling() {
        this.isEditingListValour = false;
    }
}